
import { IPermission } from '@clickster/constant-definitions/dist-esm/entities/user/types/permission';
import { API_V2 } from '../lib/axios';
import { fetchAllPaginated } from './utils/fetch-all-paginated';

const PERMISSIONS_ENDPOINT = '/permissions';

const list = async (params = {}) => {
  return fetchAllPaginated<IPermission>(API_V2, PERMISSIONS_ENDPOINT, params);
};

export const PermissionsService = {
  list,
};